//CustomerServiceButton.js;
'use strict';
import { connect } from 'react-redux';

import sendCurrentRemoteConfig from '../action/sendCurrentRemoteConfig.js';
import setIntercomData from '../action/setIntercomData.js';
import updateDataToIntercom from '../action/updateDataToIntercom.js';
import getOperationData from '../selector/getOperationData.js';
import getRouterData from '../selector/getRouterData.js';
import CustomerServiceButton from '../component/CustomerServiceButton.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  SWAG_SUPPORT_URL,
  FEATURE_CUSTOM_SERVICE_WITH_CHATROOM,
} from '../RemoteConfigKeys.js';
import getMeData from '../selector/getMeData.js';

const whitelist = [/^\/$/, /^\/settings$/, /^\/join\//, /^\/age-verify\//];

const mapStateToProps = state => {
  const isIntercomAlive =
    typeof window !== 'undefined' && window.Intercom?.booted;
  const isWithoutUserInfo = whitelist.some(regex => {
    const result = getRouterData(state, ['location', 'pathname'])?.match(regex);
    return result;
  });
  return {
    meId: getMeData(state, 'id'),
    unreadCount: getOperationData(state, ['intercom'], 'unreadCount'),
    isUserInfoRequired: !isWithoutUserInfo,
    isIntercomAlive,
    canDisplay: getOperationData(state, ['intercom'], 'canDisplayIntercom'),
    swagSupportUrl: getRemoteConfigData(state, SWAG_SUPPORT_URL),
    shouldOpenCustomerServiceWithChatroom: getRemoteConfigData(
      state,
      FEATURE_CUSTOM_SERVICE_WITH_CHATROOM
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearUnreadCount: () => dispatch(setIntercomData({ unreadCount: 0 })),
    updateDataToIntercom: () => dispatch(updateDataToIntercom()),
    sendCurrentRemoteConfig: () => dispatch(sendCurrentRemoteConfig()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerServiceButton);
